import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ReviewSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <div className="rounded-2xl overflow-hidden shadow-lg order-2 md:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=Close%20up%20photograph%20of%20a%20smartphone%20displaying%20a%20product%20review%20page%20with%20golden%20five%20star%20ratings%20and%20customer%20feedback%20text%20resting%20on%20a%20soft%20neutral%20gray%20desk%20with%20a%20coffee%20cup%20soft%20natural%20window%20light%20high%20detail%20tech%20review%20concept&width=800&height=600&seq=review-img&orientation=landscape&nocache=true"
              alt="CSSBuy Review"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-5">
              {t('reviewH2')}
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-6 text-base">
              {t('reviewText')}
            </p>
            <Link
              to="/cssbuy-review"
              className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('reviewCta')}
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}